const regexp = /^#[0-9A-Fa-f]{6}$/;

function isHexColor(value: string): boolean {
  return regexp.test(value);
}

export default isHexColor;
